import { Box, Button, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { apiUrls } from '../../../constants';
import { useNavigate, useLocation } from 'react-router-dom';
import { routeMappings } from '../../../constants';
import { ManagerStartStyles, NoFooterStyles } from '../../styles/managerStart';
import axios from 'axios';
import { getRouteMfsTaskListPage } from '../../utils/helper';
import { Task } from '../../interfaces/SurveyTaskTile';
import HtmlParser from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { getCookie } from '../../../common/utils/cookies';
import { getServerDomain } from '../../utils/helper';
import { sendPageViewDetails } from '../../../common/utils/gaEvents';
import { GARouteMappings, GAPageViewMappings } from '../../../constants/gaMappings';
import useHiddenHeaderFooter from '../../hooks/useHiddenHeaderFooter';
import { FullPageLoader } from '../../../common/components';
import Alert from '../../../common/components/Alert';
import { useAppSelector } from '../../../store/hook';

const ManagerStartRatingScreen = (): React.JSX.Element => {
  /** Page View GA method */
  useEffect(() => {
    sendPageViewDetails(GARouteMappings.SHL360_START, GAPageViewMappings.SHL360_START);
  }, []);

  const { classes } = ManagerStartStyles();

  const navigate = useNavigate();
  const location = useLocation();
  const currentWorkflowItem = useAppSelector((state) => state.currentWorkflowItem);
  const id = location.pathname.split('/')[location.pathname.split('/').length - 1];
  const [content, setContent] = React.useState('');
  const [loading, setLoading] = React.useState<boolean>(true);
  const [loadingError, setLoadingError] = React.useState<boolean>(false);
  const { t } = useTranslation();
  const { classes: customClass } = NoFooterStyles();
  const defaultItem = sessionStorage.getItem('currentWorkflowItem');

  let config;
  let tasks;

  try {
    if (defaultItem !== null && currentWorkflowItem.configuration === '') {
      config = JSON.parse(defaultItem).configuration;
    } else {
      config = currentWorkflowItem.configuration;
    }

    tasks = JSON.parse(config).configWidgetJSON.other360Tasks;
  } catch (e) {
    console.error(e);
  }

  let task;

  if (tasks && tasks.length > 0) {
    task = tasks.filter((task: Task) => task.items[0].id === id)[0];
  } else {
    task = null;
  }

  const fociName = task ? task.title : '';

  const accept = (): void => {
    navigate(`${routeMappings['MFS']}${routeMappings['MANAGER']}/${id}`);
  };

  const reject = async (): Promise<void> => {
    try {
      const config = { headers: { sid: getCookie('sid') }, withCredentials: false };
      const { status } = await axios.get(apiUrls.GET_MANAGER_START.replace('{id}', `${id}`), config);
      if (status === 200) {
        navigate(getRouteMfsTaskListPage(currentWorkflowItem));
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getData = async (): Promise<void> => {
    try {
      const config = { headers: { sid: getCookie('sid') }, withCredentials: false };
      const { data, status } = await axios.get(getServerDomain(apiUrls.GET_CUSTOM_MANAGER_START_MESSAGE), config);

      if (status === 200 || status === 304) {
        setContent(JSON.parse(data.content).content);
      }
    } catch (e) {
      console.log(e);
      setLoadingError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    !content && getData();
  });

  useHiddenHeaderFooter(customClass.screenContainer);

  if (loading) {
    return <FullPageLoader isLoading={true} />;
  }

  if (loadingError) {
    return (
      <Box className={classes.root}>
        <Box className={classes.content}>
          <Alert show={true} state="error">
            {t('administratorGenericError')}
          </Alert>
        </Box>
      </Box>
    );
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <Typography className={classes.heading}>
          {fociName.split('(')[0]}: <br />
          {content.split(':')[0]}
        </Typography>
        <Box className={classes.margintop2}>
          <Typography className={classes.instructions}>{HtmlParser(content.split(':')[1])}</Typography>
          <Typography className={`${classes.instructions} ${classes.padding1}`}>
            {HtmlParser(content.split(':')[2])}
          </Typography>
        </Box>

        <Box className={classes.buttonBlock}>
          <Button variant="outlined" className={classes.buttons} onClick={reject}>
            {t('no')}
          </Button>
          <div style={{ flexGrow: 1 }} />
          <Button variant="outlined" className={classes.buttons} onClick={accept}>
            {t('yes')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ManagerStartRatingScreen;
